import Typography from '@mui/material/Typography';

import { useFetchAllQueries } from '@/hooks/useFetchAllQueries';

import { mapLabelData } from '../../utils/mappers';
import { CardWrapper } from '../cardWrapper';
import { LabelLoader } from './labelLoader';
import { CardVariantProps } from '../../types';

export const LabelCard = ({
  clearFilters,
  columnFormatter,
  description,
  query,
  sx,
  title,
}: CardVariantProps) => {
  const queryResult = useFetchAllQueries(query);

  return (
    <CardWrapper
      clearFilters={clearFilters}
      description={description}
      query={query.baseQuery}
      queryResult={queryResult}
      renderContent={(successfulResult) => {
        const mappedData = mapLabelData(successfulResult.data, columnFormatter);

        return (
          <Typography component="div" variant="h1">
            {mappedData}
          </Typography>
        );
      }}
      renderLoading={() => <LabelLoader />}
      sx={sx}
      title={title}
    />
  );
};
